import { SURVEY_TYPE, SURVEY_RESTRICTION_METHOD } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

const shared = {
  close: 'Close',
  previousNotifications: 'Previous Notifications',
  deactivateTitle: 'Deactivate this content?',
  activateTitle: 'Activate this content?',
  deactivateConfirm: 'Learners will no longer see it. You can activate it again at any time.',
  activateConfirm: 'Learners will see it right away.',
  saved: 'Saved successfully',
  activated: 'Activated',
  deactivated: 'Deactivated',
  actionFailed: 'The operation could not be completed',
}

export const engagementStats = {
  caption: 'At a glance',
  active: 'Active',
  inactive: 'Disabled',
}

export const awarenessStrings = {
  ...shared,
  title: 'Awareness Content',
  /* The scope card, not a count. `engagementStats.total` reads "Total" and is shared
     with the other two engagement lists; this one has to say what selecting it DOES. */
  allContent: 'All content',
  subtitle: 'Editor',
  create: 'New Awareness Content',

  columns: {
    title: 'Title',
    titleEn: 'English Title',
    user: 'User',
    createdOn: 'Creation Date',
    isActive: 'Active',
  },

  active: 'Active',
  inactive: 'Disabled',

  row: {
    deactivate: 'Deactivate',
    activate: 'Activate', edit: 'Update', delete: 'Delete',
    views: 'Readers', exportPackage: 'Export tenant package' },

  // See the note on `views` in strings.ar.js.
  views: {
    title: 'Who read this bulletin',
    empty: 'Nobody has opened this bulletin yet',
    failed: 'The reader list could not be loaded',
    columns: {
      name: 'Name',
      username: 'Username',
      email: 'Email',
      seenOn: 'Read on',
    },
  },

  form: {
    saved: 'Operation completed successfully',
    titleAr: 'Arabic Title',
    contentAr: 'Arabic Content',
    titleEn: 'English Title',
    contentEn: 'English Content',
    cover: 'Cover Photo',
    state: 'Enabled',
    isActive: 'Active',

    steps: {
      content: 'Article content',
      media: 'Media and attachments',
      audience: 'Publishing and audience',
    },
    videos: 'Videos',
    addVideo: 'Upload a video',
    noVideos: 'No videos uploaded',
    attachments: 'Manage Attachments',
    addAttachment: 'Add an attachment',
    noAttachments: 'No attachments',
    attachmentsFailed: 'The bulletin was saved, but one of its attachments was not',
    attachmentNameAr: 'Attachment name in Arabic',
    attachmentNameEn: 'Attachment name in English',
    fileAr: 'Arabic file',
    fileEn: 'English file',
    remove: 'Delete',
    groups: 'Allow only to groups',
    selectAll: 'Select All',
    filter: 'Filter',
    save: 'Save',
    required: 'Field required',
  },

  deleteConfirm: 'Delete this article?',
  deleted: 'Operation Completed Successfully',
  settings: {
    tab: 'Settings',
    contentTab: 'Bulletins',
    screen: 'Awareness screen',
    screenHint: 'Whether trainees are offered the screen, and what it is called',
    enabled: 'Show the awareness screen to trainees',
    enabledHint: "When off, the screen does not appear in a trainee's menu",
    nameAr: 'Screen name in Arabic',
    nameEn: 'Screen name in English',
    nameHint: "The name shown in a trainee's menu",
    disabledNote: 'Saving will hide the awareness screen from every trainee.',
    notification: 'Notifications',
    notificationHint: 'Notify trainees about new bulletins',
    notifyOn: 'Active',
    notifyOff: 'Not active',
    save: 'Save settings',
    saving: 'Please wait...',
    saved: 'The settings were saved',
  },

}

export const policiesStrings = {
  ...shared,
  title: 'Manage Cybersecurity Policies',
  /* The scope card, not a count. `engagementStats.total` reads "Total" and is shared
     with the other two engagement lists; this one has to say what selecting it DOES. */
  allPolicies: 'All policies',
  subtitle: 'Add new Policy or edit existing one.',
  create: 'New Policy',

  enableFeature: 'Enable the policies feature', // WorkspacePoliciesSettings.LocChkBxEnable

  /** The screen's three sections — the legacy splits the same ground into tabs. */
  sections: {
    policies: 'Policies',
    categories: 'Categories', // WorkspacePoliciesSettings.PolicyCategory
    settings: 'Settings',
  },

  state: {
    activate: 'Activate', // LblPolicyStateEnabled
    deactivate: 'Deactivate', // LblPolicyStateDisabled
  },

  /** Policy categories — PolicyCategoryModal.cshtml. */
  categories: {
    title: 'Policy categories',
    hint: 'Categories are what a user sees when policies are shown as a grid',
    add: 'New category',
    edit: 'Edit category',
    nameAr: 'Arabic name',
    nameEn: 'English name',
    enabled: 'This category is active',
    empty: 'No categories yet',
    deleteConfirm: 'Delete this category?',
  },

  /** Policy settings — SettingsTab.cshtml. */
  settings: {
    viewing: 'How policies are shown',
    viewingHint: 'What a user sees on their policies page',
    viewingGrid: 'A grid of categories',
    viewingList: 'One flat list',
    externalUrl: 'External policies URL',
    externalUrlHint: 'When set, policies open from this address instead of the built-in page',
    pageTitle: 'Policies page title',
    pageTitleHint: 'The heading a user sees above their policies',
    pageTitleAr: 'Arabic title',
    pageTitleEn: 'English title',
    notifications: 'Policy notifications',
    newPolicy: 'Notify when a policy is added',
    agreement: 'Notify when agreement is required',
    templateReady: 'Template ready',
    templateMissing: 'No template',
    save: 'Save', // Resources.Save
  },
  columns: {
    index: 'ID',
    name: 'Arabic Name',
    nameEn: 'English Name',
    version: 'Version',
    createdOn: 'Creation Date',
    forceUsers: 'Force Users',

    evaluationStartDate: 'Enforcement date',
    status: 'Enabled',
  },

  active: 'Active',
  inactive: 'Disabled',
  yes: 'Yes',
  no: 'No',

  users: {
    title: 'Users',
    open: 'Users list',
    columns: {
      name: 'User',
      version: 'Version',
      download: 'Download Status',
      downloadDate: 'Download Date',
      accept: 'Acknowledgement',
      acceptDate: 'Acknowledgement Date',
    },
    searchPlaceholder: 'User',
    allUsers: 'All',
    viewed: 'Viewed',
    notViewed: 'Not viewed',
    empty: 'This policy has not been issued to any user',
    exportExcel: 'Export to Excel',
    exportPdf: 'Export to PDF',
    exportFailed: 'The file could not be produced',
  },

  row: {
    edit: 'Update',
    sendEmail: 'Send Email',
    delete: 'Delete',
    fileAr: 'Download Arabic file',
    fileEn: 'Download English file',
  },

  form: {
    identity: 'Policy details',
    audience: 'Audience',
    documents: 'Policy files',
    fileTypes: 'PDF',  // SavePolicyHandler accepts nothing else
    forceUsersHint: 'Users cannot continue using the system until they accept it',
    nameAr: 'Arabic title',
    nameEn: 'English title',
    version: 'Version',
    kind: 'Policy Type',
    acknowledgement: 'Acknowledgement',
    readOnly: 'For information',
    category: 'Policy Category',
    categoryPlaceholder: 'Select Type',
    fileAr: 'Upload Arabic Policy file',
    fileEn: 'Upload English Policy file',
    forceUsers: 'Force Users Acceptance',
    evaluationStartDate: 'Evaluation Start Date',
    groups: 'Apply to Specific Groups',
    selectAll: 'Select all',
    filter: 'Filter',
    add: 'Add',
    save: 'Save',
    notAvailable: 'Policies cannot be saved from this screen yet — this action has not been migrated to the API.',
    required: 'Field required',
  },

  deleteConfirm: 'Delete this policy?',
  deleted: 'Operation Completed Successfully',
}

export const surveysStrings = {
  ...shared,
  title: 'Surveys Management',
  subtitle: 'Manage all the Surveys in the system',
  create: 'New Survey',
  enableFeature: 'Enable Survey Feature',
  activeOnly: 'Show Active Survey Only',
  /* The scope card, not a count. `engagementStats.total` reads "Total" and is shared
     with awareness and policies; this one has to say what selecting it DOES. */
  allSurveys: 'All surveys',

  columns: {
    index: 'ID',
    title: 'Title',
    type: 'Survey Type',
    createdOn: 'Creation Date',
    updatedOn: 'Last Updated',
    status: 'Enabled',
    mandatory: 'Mandatory',
    answers: 'Answers Count',
  },

  active: 'Enabled',
  inactive: 'Disabled',
  yes: 'Mandatory',
  no: 'optional',

  types: {
    [SURVEY_TYPE.GENERAL]: 'Public',
    [SURVEY_TYPE.COURSE]: 'Learning Course',
    [SURVEY_TYPE.PROGRAM]: 'Learning Program',
  },

  row: {
    update: 'Update',
    details: 'Survey Details',
    sendEmail: 'Send Email',
    delete: 'Delete',
  },

  form: {
    saved: 'Operation completed successfully',
    steps: { basics: 'Basic Infos', groups: 'Publicity', rules: 'Entry rules' },
    nameAr: 'Arabic title',
    descriptionAr: 'Arabic Description',
    nameEn: 'English title',
    descriptionEn: 'English Description',
    enabled: 'This survey is active',
    type: 'Survey Type',
    course: 'Course',
    program: 'Learning programme',
    chooseTarget: 'Choose from the list',
    restrictToGroups: 'Accosiate thie survey with the following groups',
    restrictHint: 'When enabled, the survey is shown only to the selected departments',
    groups: 'Selected departments',
    selectAll: 'Select All',
    filter: 'Filter',
    mandatory: 'Force users to take the survey',
    restriction: 'Open Survey Options',
    // See the note on `timeRestricted` in strings.ar.js.
    timeRestricted: 'Limit the survey to a period',
    timeRestrictedHint: 'When on, the survey is not offered outside the period below',
    period: 'Period',
    from: 'From',
    to: 'To',
    restrictions: {
      [SURVEY_RESTRICTION_METHOD.COURSE_AFTER_WATCHING_CONTENT]: 'After Watching Content',
      [SURVEY_RESTRICTION_METHOD.COURSE_AFTER_TAKING_EXAM]: 'After Taking Exam',
      [SURVEY_RESTRICTION_METHOD.PROGRAM_AFTER_FINISHING_ALL_COURSES]: 'After watching all the courses',
      [SURVEY_RESTRICTION_METHOD.PROGRAM_AFTER_FINISHING_ALL_COURSES_SUCCESSFULLY]: 'After finishing every exam',
    },
    next: 'Next',
    back: 'Previous',
    save: 'Save',
    required: 'Field required',
  },

  deleteConfirm: 'Delete this survey?',
  deleted: 'Operation Completed Successfully',

  report: {
    title: 'Survey details',
    total: (n) => (n === 0 ? 'Nobody has answered this survey yet' : `Total answers: ${n}`),
    noAnswers: 'No answers to this question',
    yes: 'Yes',
    no: 'No',
    empty: 'This survey has no questions',
    emptyHint: 'Add questions to the survey and their results appear here.',
    // See the note in strings.ar.js.
    download: 'Download report',
    downloadFailed: 'The report could not be downloaded',
  },
}

export const assessmentsStrings = {
  ...shared,
  title: 'Manage Assessments',
  subtitle: 'Add new Assessment or edit existing one.',
  create: 'Add New Assessment',
  enableFeature: 'Activate Assessments Feature',

  columns: {
    index: 'ID',
    title: 'Title',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Enabled',
    mandatory: 'Mandatory',
    passed: 'Success Count',
    failed: 'Failure Count',
    absent: 'Unattended Count',
  },

  active: 'Enabled',
  inactive: 'Disabled',
  yes: 'Mandatory',
  no: 'Not Mandatory',

  report: {
    title: 'Assessment report',
    passMark: 'Pass mark',
    questionsCount: 'Questions',
    searchUsers: 'Search by name or e-mail',
    tabs: {
      passed: 'Succeeded List',
      failed: 'Failure List',
      unattended: 'Unattended List',
      answers: 'Answers Level',
    },
    stats: {
      audience: 'Targeted',
      passed: 'Passed',
      failed: 'Failed',
      unattended: 'Did not attend',
    },
    columns: {
      index: '#',
      name: 'Name',
      userName: 'User Name',
      email: 'Email',
      department: 'Department',
      employeeId: 'Employee ID',
      examDate: 'Exam Date',
      score: 'Result',
      question: 'Question',
      category: 'Topic',
      difficulty: 'Difficulty Level',
      answers: 'Total Answers',
      correct: 'Correct Answers Ratio',
    },
    empty: {
      passed: 'Nobody has passed this assessment yet',
      failed: 'Nobody has failed this assessment',
      unattended: 'Nobody is left — everyone targeted has sat it',
      answers: 'No answers have been recorded for this assessment yet',
    },
  },

  row: {
    update: 'Update',
    details: 'Assessment Reports',
    sendEmail: 'Send Email',
    delete: 'Delete',
  },

  form: {
    groups: 'Assign this assessment to these departments',
    identity: 'Identity',
    schedule: 'Period and grading',
    scope: 'Scope',
    passHint: 'The percentage required to pass the assessment',
    nameAr: 'Arabic title',
    descriptionAr: 'Arabic Description',
    nameEn: 'English title',
    descriptionEn: 'English Description',
    startDate: 'Start Date',
    endDate: 'End Date',
    enabled: 'Make this Assessment active',
    mandatory: 'Make this Assessment mandatory',
    questionsCount: 'Questions Count',
    passLimit: 'Success Percentage',
    publicity: 'Publicity',
    public: 'Public',
    private: 'Private',
    categories: 'Topics',
    selectAll: 'Select All',
    filter: 'Filter',
    save: 'Save',
    required: 'Field required',
  },

  deleteConfirm: 'Delete this assessment?',
  deleted: 'Operation Completed Successfully',
}
